module.exports = __webpack_public_path__ + "img/mv--element.464d0b2e.png";